import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerificationRoutingModule } from './verification-routing.module';
import { ImageCardComponent } from './components/image-card/image-card.component';
import { ProjectInfoHeaderComponent } from './components/project-info-header/project-info-header.component';
import { FormsModule } from '@angular/forms';
import { CarouselModule } from 'primeng/carousel';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { GalleriaModule } from 'primeng/galleria';
import { PaginatorModule } from 'primeng/paginator';
import { VerificationDashboardComponent } from './components/verification-dashboard/verification-dashboard.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { FileUploadComponent } from './Common/file-upload/file-upload.component';
import { SharedModule } from '../shared/shared.module';
import { MultiSelectModule } from 'primeng/multiselect';
import { TreeModule } from 'primeng/tree';
import { ProjectValidationCriteriaResponseComponent } from './components/project-validation-criteria-response/project-validation-criteria-response.component';

@NgModule({
  declarations: [
    ImageCardComponent,
    ProjectInfoHeaderComponent,
    VerificationDashboardComponent,
    FileUploadComponent,
    ProjectValidationCriteriaResponseComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    VerificationRoutingModule,
    CarouselModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
    GalleriaModule,
    PaginatorModule,
    AutoCompleteModule,
    CalendarModule,
    ConfirmDialogModule,
    SharedModule,
    MultiSelectModule,
    TreeModule
  ],
  providers: [ConfirmationService]
})
export class VerificationModule { }
